<!--
 * @Author: your name
 * @Date: 2020-07-02 15:13:19
 * @LastEditTime: 2021-12-22 18:57:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\views\home\home.vue
--> 
<template>
    <div :class="[`${pageClass}-main_cont`]">
      <div class="banner-box">
        <div class="banner-list">
          <el-carousel :interval="5000" arrow="always">
            <!-- v-loading="bannerLoading" -->
            <el-carousel-item v-for="(item, index) in picArr" :key="index">
              <img :src="`${ backURL }/apis/upload/gk-resource/carousel/${item.url}`">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="subject-list" v-loading="loading">
        <div class="list" v-for="(subject, index) in subjectList" :key="index" @mouseover.stop="changeActive(index)" @mouseout.stop="removeActive()">
          <subject-card :subject="subject" :subject-index="index" :active.sync="active"></subject-card>
        </div>
        <div class="time-right">
          <img src="../../assets/images/home/time.png" alt="">
          <span class="day">{{ date.d }}</span>
        </div>
      </div>

      <div class="kf">
        <p class="kftitle">扫码关注 </p>
        <img src="../../assets/images/home/wxgzh.jpg" alt="">
        <p>“我要尚壹本”</p>
        <p>公众号</p>
      </div>

      <!-- 登陆新增 -->
      <el-dialog
        title="完善信息"
        :visible.sync="centerDialogVisible"
        height="auto"
        center
        custom-class="dialog_visible"
        @close="closeDialog">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="form_user">
            <div class="tips">账号和密码默认一致,可以去账号设置中修改密码</div>
            <el-form-item label="账号" prop="username">
              <el-tooltip class="item" effect="dark" content="账号长度为6-20,不能为纯数字,可使用字母、数字、_" placement="top">
                <el-input v-model="ruleForm.username" maxlength="20" placeholder="密码和账号默认一致"></el-input>
              </el-tooltip>
            </el-form-item>
            <!-- <el-form-item label="密码" prop="pass">
              <el-tooltip class="item" effect="dark" content="密码长度为6-20,可使用字母、数字、_" placement="top">
                <el-input type="password" maxlength="20" v-model="ruleForm.pass" placeholder="请输入密码" autocomplete="off"></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="确认密码" maxlength="20" prop="confirm_pass">
              <el-tooltip class="item" effect="dark" content="密码长度为6-20,可使用字母、数字、_" placement="top">
                <el-input type="password" v-model="ruleForm.confirm_pass" placeholder="请确认密码" autocomplete="off"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <el-form-item label="选择省份">
              <el-cascader
                v-model="addressArr"
                :options="address"
                @change="addressChange">
              </el-cascader>
            </el-form-item>
            <!-- <el-form-item label="选择省份" prop="province">
              <el-select v-model="ruleForm.province" placeholder="请选择省份" @change="getTypeByProv">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label prop="soa" v-if="gkType == 0">
              <div class="csoa">
                <div class="tip">请选择文/理科</div>
                <div>
                  <el-radio-group v-model="ruleForm.soa">
                    <el-radio label="理科"></el-radio>
                    <el-radio label="文科"></el-radio>
                  </el-radio-group>
                </div>
              </div>
            </el-form-item>
            <el-form-item label prop="checkList" v-if="gkType == 1">
              <div class="csoa">
                <div class="tip">请选择学科</div>
                <div>
                  <el-checkbox-group v-model="ruleForm.checkList" :max="6">
                    <el-checkbox label="语文" disabled></el-checkbox>
                    <el-checkbox label="数学" disabled></el-checkbox>
                    <el-checkbox label="英语" disabled></el-checkbox>
                    <el-checkbox label="物理"></el-checkbox>
                    <el-checkbox label="化学"></el-checkbox>
                    <el-checkbox label="生物"></el-checkbox>
                    <el-checkbox label="政治"></el-checkbox>
                    <el-checkbox label="历史"></el-checkbox>
                    <el-checkbox label="地理"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-form-item>
            <!-- <el-form-item label="学校名称" prop="school">
              <el-tooltip class="item" effect="dark" content="学校名称最长为20" placement="top">
                <el-input v-model="ruleForm.school" placeholder="请输入学校名称" maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <!-- <el-form-item label="真实姓名" prop="name">
              <el-tooltip class="item" effect="dark" content="姓名长度为2-20" placement="top">
                <el-input v-model="ruleForm.name" placeholder="请输入真实姓名" maxlength="20"></el-input>
              </el-tooltip>
            </el-form-item> -->
            <el-form-item label prop="agree">
              <el-checkbox v-model="ruleForm.agree">同意</el-checkbox>
              <a target="_blank" href="#/register/argeement">用户协议</a>
            </el-form-item>
          </div>
          <el-form-item label>
            <!-- :style="{'background-color': isDisabled ? '#585858' : '#5c307d','cursor':isDisabled ? '':'pointer'}" :disabled="isDisabled" -->
            <el-button type="primary"  @click="submitForm('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
</template>
<script>
import subjectCard from './subject-card'
import high_school_subjcet from "@/assets/js/subject-data.js";
import address from '@/assets/js/address'
export default {
  name: "mainss",
  data() {
    let valid_num = /^\d+$/g;
    //空格
    let space = /\s/g;
    let valid_no_chinese = /^[^\u4e00-\u9fa5]+$/g;
    var un_is_nan = (rule, value, callback) => {
      if (value.match(valid_num)) {
        callback(new Error("账号不能为纯数字"));
      } else if (!value.match(valid_no_chinese)) {
        callback(new Error("账号不能输入中文"));
      } else if (space.test(value)) {
        callback(new Error("账号不能输入空格"));
      } else {
        this.$HTTP.executeGet(this.$APIS.USERNAME_EXISTS+this.ruleForm.username,this).then(res=>{
          if(!res.valid){
            callback(new Error("账号已存在"));
          }else{
            callback();
          }
        });
      }
    };
    var choose_subject = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error("请至少选择六科"));
      } else {
        callback();
      }
    };
    var agree_is = (rule, value, callback) => {
      if (!this.ruleForm.agree) {
        callback(new Error("请同意用户协议"));
      } else {
        callback();
      }
    };
    return {
      addressArrlength: 0,
      addressArr: [],
      address,
      provinceId: null,
      cityId: null,
      countyId: null,
      bannerLoading: true,
      loading: true,
      countdownNum: 0,
      getBeforeGaoKaoDay: '',
      gaoKaoYear: '2021', // 当前年份
      pageClass: 'home',
      picArr: [
        { url: '0-all.jpg' },
        { url: '5-sx.jpg' },
        { url: '1-yw.jpg' },
        { url: '2-sx.jpg' },
        { url: '3-yy.jpg' },
        { url: '4-wl.jpg' },
        { url: '1-all.jpg' }
      ],
      backURL : this.$config.backURL,
      active: null,
      date: {
        d: '00',
        h: '00',
        m: '00',
        s: '00'
      },
      subjectList: [
         {
          id: 10,
          url: require('../../assets/images/home/sx.png'),
          msg: '奥秘无穷，智提慧升',
          show: false,
          name: '数学'
        },
        {
          id: 12,
          url: require('../../assets/images/home/wl.png'),
          msg: '究根问底，探密未知',
          show: false,
          name: '物理'
        },
        
       
        {
          id: 11,
          url: require('../../assets/images/home/yy.png'),
          msg: '内外兼修，师夷制夷',
          show: false,
          name: '英语'
        },
        {
          id: 9,
          url: require('../../assets/images/home/yw.png'),
          msg: '一贯古今，文情并进',
          show: false,
          name: '语文'
        },
        
        {
          id: 13,
          url: require('../../assets/images/home/hx.png'),
          msg: '质量互化，变幻万千',
          show: false,
          name: '化学'
        },
        {
          id: 14,
          url: require('../../assets/images/home/sw.png'),
          msg: '万物繁衍，生生不息',
          show: false,
          name: '生物'
        },
        {
          id: 16,
          url: require('../../assets/images/home/dl.png'),
          msg: '天风地雨，亘古瞬移',
          show: false,
          name: '地理'
        },
        {
          id: 15,
          url: require('../../assets/images/home/ls.png'),
          msg: '千载纵横，鉴古观今',
          show: false,
          name: '历史'
        },
        {
          id: 17,
          url: require('../../assets/images/home/zz.png'),
          msg: '运筹帷幄，一颗红心',
          show: false,
          name: '政治'
        }
      ],

      // 微信登陆需增
      //校验规则
      rules: {
        username: [
          { required: true, message: "请设置账号", trigger: "blur" },
          { min: 6, max: 20, message: "账号长度为6-20", trigger: "blur" },
          { validator: un_is_nan, trigger: "blur" },
        ],
        province: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        checkList: [{ validator: choose_subject, trigger: "change" }],
        soa: [{ required: true, message: "请选择学科", trigger: "change" }],
        // name: [{ required: true, message: "请输入真实姓名", trigger: "blur" }],
        agree: [
          { required: true, message: "请同意用户协议", trigger: "change" },
          { validator: agree_is, trigger: "change" },
        ]
      },
      code: '',
      wxData: {}, // 微信返回的基本信息
      openId: '',
      ruleForm: {
        //表单数据
        username: "", // 用户名
        pass: "", // 密码
        confirm_pass: "", // 确认密码
        province: "", // 省份
        checkList: ["语文", "数学", "英语"],
        soa: "",
        school: "", // 设置学校
        name: "", // 
        agree: true,
        phone : '',
        very_code : ''
      },
      nickname: '',
      //点击注册,样式变化
      isDisabled : false,
      centerDialogVisible: false,
      //渲染数据
      gkType: 0
    };
  },
  components: {
    subjectCard
  },
  methods: {
    addressChange (val) {
      this.addressArrlength = val.length
      this.getTypeByProv(val[0])
      if (!this.addressArrlength) {
        this.provinceId = null
      } else if (this.addressArrlength === 1) {
        this.provinceId = val[0]
      } else if (this.addressArrlength === 2) {
        this.provinceId = val[0]
        this.cityId = val[1]
      } else {
        this.provinceId = val[0]
        this.cityId = val[1]
        this.countyId = val[2]
      }
    },
    getTypeByProv(val) {
      this.$HTTP
        .executeGet(this.$APIS.GET_TYPE_BY_PROVINCE + val, this)
        .then((response) => {
          this.gkType = response.gkType;
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isDisabled = true;
          this.register_user();
        } else {
          return false;
        }
      });
    },
    countdown() {
      let user_info = window.localStorage.getItem("userinfo");
      let uesr = JSON.parse(user_info);
      if(uesr != null && uesr.examYear) {
        this.gaoKaoYear = uesr.examYear
      }
      let nowTime = new Date().getTime()
      let gaokaoTime = new Date(this.gaoKaoYear, 6 - 1, 7).getTime()
      if(gaokaoTime - nowTime < 0) {
        ++this.gaoKaoYear
      }
      
      let gaokaoTimetwo = new Date(this.gaoKaoYear, 6 - 1, 7).getTime();
      let surplus = parseInt((gaokaoTimetwo - nowTime)/1000);

      setInterval(() => {
        this.date.d = parseInt(surplus / (24 * 60 * 60)) < 10 ? '0' + parseInt(surplus / (24 * 60 * 60)) : parseInt(surplus / (24 * 60 * 60));
        this.date.h = parseInt(surplus / (60 * 60) % 24) < 10 ? '0' + parseInt(surplus / (60 * 60) % 24) : parseInt(surplus / (60 * 60) % 24);
        this.date.m = parseInt(surplus / 60 % 60) < 10 ? '0' + parseInt(surplus / 60 % 60) : parseInt(surplus / 60 % 60);
        this.date.s = parseInt(surplus % 60) < 10 ? '0' + parseInt(surplus % 60) : parseInt(surplus % 60);
        surplus -= 1
      }, 1000)
    },
    changeActive(index) {
      this.active = index
    },
    removeActive() {
      this.active = null
    },
    // getBannerList() {
    //   this.$HTTP.executePost(this.$APIS.GET_TEST_POSTERS, {}, this).then((res) => {
    //     if(!res.code) {
    //       this.picArr = res.data;
    //     }
    //     this.bannerLoading = false
    //   })
    // },
    getSubjectList() {
        this.$HTTP.executePost(this.$APIS.GET_EXPERT_EVALUATION_SUBJECTID, { 'appId':100 }, this).then((res) => {
            if(!res.code) {
              const list = res.data;
              for (let i = 0; i < list.length; i++) {
                const element1 = list[i];
                for (let index = 0; index < this.subjectList.length; index++) {
                  const element2 = this.subjectList[index];
                  if(element1.subjectId == element2.id) {
                    element2.show = true
                    element2.url = element1.photoPath
                    element2.briefIntroduction = element1.briefIntroduction
                  }
                }
              }
            } else {
              this.$message.error('调用接口失败')
            }
            this.loading = false
          }) 
    },
    closeDialog() {
      this.$message.error('基本信息设置失败, 请重新扫码登录')
      this.centerDialogVisible = false
    },
    getSubjects(){
      let subject_ids_str ='' ;
      let SS = this.ruleForm.checkList;
      let HSS = high_school_subjcet;
      let SISA = [];
      if(this.ruleForm.gkType == 0){
        if(this.ruleForm.soa == 0){
          this.ruleForm.checkList = ['语文','数学','英语','物理','化学','生物'];
        }else{
          this.ruleForm.checkList = ['语文','数学','英语','历史','政治','地理'];
        }
      }
      //i为键值
      for( var i in HSS){
        //j为数组索引
          for( var j in SS){
              if(HSS[i] == SS[j]){
                SISA.push(i);
              }
          }
      }
      subject_ids_str = SISA.toString();
      SISA = [];
      return subject_ids_str;
    },

    // 微信注册接口
    register_user() {
      let subject_ids_str = this.getSubjects();
      if (!this.provinceId) {
        this.$message.error('请选择省份')
        return false
      }
      let regInfo = {
        schoolId: 280889,
        gradeId: 6, //年级id
        termId: 3, //学段id
        provinceId: this.provinceId,
        countyId: this.countyId,
        cityId: this.cityId,
        subject_ids: subject_ids_str,
        name: this.ruleForm.name,
        username: this.ruleForm.username,
        password: this.ruleForm.username,
        type: 0,
        entrepriseId: 1,
        nickname: this.nickname
      };
      this.$HTTP
        .executePost(this.$APIS.USER_REGISTER_USERNAME_PASSWORD, regInfo, this)
        .then((response) => {
          if (response.code != 0) {
            this.$message.error("基本信息注册错误!");
            this.isDisabled = false;
            return;
          }
          this.user_login()
          this.$router.push("/");
        });
    },
    // 登陆接口
    user_login() {
      let data = {
        username: this.ruleForm.username,
        password: this.ruleForm.username,
        openid: this.wxData.openid || ''
      };
      this.$HTTP
        .executePost(this.$APIS.USER_LOGIN, data, this)
        .then((response) => {
          if (response.msg == "Success!") {
            let userinfo = response.data;
            userinfo.password = data.password;
            var userinfo_json = JSON.stringify(userinfo);
            window.localStorage.setItem("userinfo", userinfo_json);
            this.$root.eventHub.$emit('changePath', 'home')
            this.$router.push({
              path: '/tfedu_common/home'
            })
          } else {
            this.isDisabled = false;
            this.$message.error(response.msg);
          }
        });
    },
  },
  created() {
    let model = localStorage.getItem('model') ? localStorage.getItem('model') : ''
    if (model != 'client') { // 判断是不是客户端页
      if(window.env != 'dev'){
        window.location.href = window.frontURL + '/web/index.html'
      }
      
    }
    // 处理学科
    this.getSubjectList()
    // 倒计时
    this.countdown()
    // banner
    // this.getBannerList()

    // 微信登陆新增
    this.code = window.location.href.substr(1).split('&')[0].split('=')[1]
    if (this.code) { // 有值 表示微信登录
      this.$store.commit('changeIsShowLogin', false);
      this.$HTTP
        .executeGet(this.$APIS.WX_LOGIN_GET_CODE +  '?code=' + this.code, this)
        .then((response) => {
          if(response.code == 0) {
            this.wxData = response.data
            if(this.wxData.bindState == 0) { // 未绑定需要注册
              this.openId = response.data.openid
              this.nickname = response.data.nickname
              this.ruleForm.username = this.openId.substring(this.openId.length - 10, this.openId.length);
              // 随机生成4位数
              let num = Math.random().toString().substring(2, 6)
              this.ruleForm.username = `${this.ruleForm.username}${num}`
              this.centerDialogVisible = true
            } else {
              // 已经绑定 直接登录
              let userinfo = response.data;
              var userinfo_json = JSON.stringify(userinfo);
              window.localStorage.setItem('userinfo', userinfo_json);
              this.$root.eventHub.$emit('changePath', 'home')
              this.$router.push({
                path: '/tfedu_common/home'
              })
            }
          }
        })
    }
  }
};
</script>
// lang="stylus" lang="scss"
<style lang="scss" scoped>

.home-main_cont {
  /deep/ .el-dialog {
    width: 600px;
  }

  /deep/ .dialog_visible {
    height: auto;
    .el-form {
      .tips {
        font-size: 16px;
        color: #585858;
        line-height: 30px;
        margin-left: 100px;
      }
      .el-form-item {
        margin-bottom : 20px;
        .el-form-item__label {
          font-size: 18px;
          color: #aaaaaa;
          text-align: center;
          height: 48px;
          line-height: 48px;
        }

        .el-form-item__content {
          .el-input {
            width: 337px;
            height: 48px;
            float : left;
            input {
              background-color: #f7f7f7;
              border-radius: 50px;
              height: 48px;
              font-size: 18px;
              color: #585858;
              float : left;
            }
            .el-icon-circle-check{
                color : green;
            }
            
          }
          .getcode{
              position : relative;
              float : left;
              padding-left: 10px;
              padding-top : 2px;
              font-size : 18px;
          }

          .el-radio-group {
            width: 337px;
            margin-left: 90px;
            margin-top: 50px;

            .el-radio__label {
              color: #585858;
              font-size: 19px;
            }

            .el-radio__input {
              cursor: pointer;
              vertical-align: middle;
              width: 20px;
              height: 20px;
            }
          }

          .el-checkbox {
            margin-left: 110px;

            .el-checkbox__label {
              color: #aaaaaa;
            }
          }

          a {
            color: #5c307d;
            margin-left: 0px;
          }

          .el-checkbox-group {
            .el-checkbox {
              float: left;
              margin-left: 7%;
            }

            .el-checkbox__label {
              font-size: 14px;
              color: #585858;
            }
          }

          .el-form-item__error{
            color: #F56C6C;
            font-size: 14px;
            line-height: 1;
            padding-top: 0;
            position: absolute;
            top: 100%;
            left: 0;
          }
        }
      }
    }

    .el-button {
      width: 337px;
      height: 48px;
      text-align: center;
      line-height: 0px;
      
      border-radius: 50px;
      font-size: 21px;
      color: #ffffff;
      margin-top: 0px;
      
    }
  }
    .banner-box {
      width: 100%;
      height: 260px;
      margin-top: 32px;
      .banner-list {
        width: 1520px;
        height: 100%;
        margin: 0 auto;
        /deep/ .el-carousel {
          height: 100%;
          .el-carousel__container {
            height: 100%;
            .el-carousel__item {
              img {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    width: 100%;
    height: auto;
    float: left;
    margin-bottom: 50px;
    .title {
      font-size: 40px;
      color: #5c307d;
      margin-top: 65px;
      text-align: center;
      font-weight: 900;
    }
    .subject-list {
      width: 1225px;
      margin: 0 auto;
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      position: relative;
      .list {
        width: 387px;
        height: 172px;
        border-radius: 9px;
        position: relative;
        margin-top: 32px;
        overflow: hidden;
        cursor: pointer;
      }
      .time-right {
        width: 132px;
        position: absolute;
        right: -160px;
        top: 30px;

        img {
          width: 100px;
          height: auto;
        }

        .day {
          width: 65px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          font-size: 22px;
          color: #fff;
          position: absolute;
          top: 199px;
          left: 17px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .kf {
    width: 160px;
    height: 200px;
    background: #fff;
    border-radius: 9px;
    position: fixed;
    top: 488px;
    right: 0;
    img {
      width: 132px;
      height: 132px;
      display: block;
      margin: 0 auto;
    }
    p {
      font-size: 12px;
      color: #898989;
      text-align: center;
      line-height: 18px;
    }
    .kftitle {
      padding-top: 10px;
    }
  }
</style>